import { map } from 'lodash'
import { useCallback, useMemo } from 'react'
import { graphql, useFragment, useMutation } from 'react-relay'

import {
  type useDeetCriteria_query$data,
  type useDeetCriteria_query$key
} from '@/__generated__/useDeetCriteria_query.graphql'
import { type useDeetCriteriaMutation } from '@/__generated__/useDeetCriteriaMutation.graphql'

type CommitAsyncFn = (deetIds: string[]) => Promise<useDeetCriteria_query$data>

export const useDeetCriteria = (
  queryRef?: useDeetCriteria_query$key | null | undefined
): [string[], CommitAsyncFn, boolean] => {
  const queryData = useFragment(
    graphql`
      fragment useDeetCriteria_query on Query {
        currentUser {
          deetCriteria(orderBy: [DEET_BY_DEET_ID__SEQUENCE_ASC]) {
            nodes {
              deetId
            }
          }
        }
      }
    `,
    queryRef
  )
  const data = useMemo(
    () => map(queryData?.currentUser?.deetCriteria.nodes, 'deetId'),
    [queryData?.currentUser?.deetCriteria.nodes]
  )
  const [commit, isPending] = useMutation<useDeetCriteriaMutation>(graphql`
    mutation useDeetCriteriaMutation($input: UpdateDeetCriteriaInput!) {
      updateDeetCriteria(input: $input) {
        query {
          ...useDeetCriteria_query
        }
      }
    }
  `)

  const commitAsync = useCallback<CommitAsyncFn>(
    (deetIds: string[]) =>
      new Promise((resolve, reject) =>
        commit({
          onCompleted: (response, errors) => {
            if (errors) {
              reject(errors)
            } else {
              // @ts-ignore false negative
              resolve(response)
            }
          },
          variables: {
            input: {
              deetIds
            }
          }
        })
      ),
    [commit]
  )

  return [data, commitAsync, isPending]
}
